var React = require('react');

function MinMaxInput (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 0.25L1 21.75","stroke":"#D4D3D0","strokeWidth":"2"}));
}

MinMaxInput.defaultProps = {"width":"4","height":"22","viewBox":"0 0 6 22","fill":"none"};

module.exports = MinMaxInput;

MinMaxInput.default = MinMaxInput;
